import { useTranslation } from 'react-i18next';

import { PageMeta } from '@/components/layout/PageMeta';
import { BareLayout } from '@/layouts/BareLayout';

export function EntryHelpPage() {
  const { t } = useTranslation('cashier');

  return (
    <BareLayout>
      <PageMeta title={t('meta.titleFallback')} />
      <h1 className="text-text text-xl font-semibold tracking-tight" tabIndex={-1}>
        {t('entryHelp.title')}
      </h1>
      <p className="text-text-muted mt-3 text-sm leading-relaxed">{t('entryHelp.body')}</p>
      <p className="text-text-muted mt-2 text-sm leading-relaxed">{t('entryHelp.note')}</p>
    </BareLayout>
  );
}
